import { useRouter } from "next/router";
import { Button } from "./ui/button";
import { LockKey } from "@phosphor-icons/react";
import { useAtom } from "jotai";
import { purchasePopup, loginPopup } from "@/Atoms";
import {
  Dialog,
  DialogContent,
} from "@/components/ui/dialog";

function ClaimModalPay({ isOpen, onClose }) {
  const router = useRouter();

  async function toPricing() {
    if (onClose) onClose();
    
    // If already on angel investors register page, just scroll
    if (router.pathname === '/angel-investors/register') {
      const planElement = document.getElementById('angel-investor-plan');
      if (planElement) {
        planElement.scrollIntoView({ behavior: 'smooth' });
      }
      return;
    }
    
    const planElement = document.getElementById('angel-investor-plan');
    if (planElement) {
      planElement.scrollIntoView({ behavior: 'smooth' });
    }
  }

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="p-4 bg-white text-background">
        <div className="text-center">
          <LockKey className="mx-auto mb-3 text-5xl text-orange-1" />
          <p className="mb-2 text-2xl font-semibold leading-tight tracking-tight">
            Subscription Required
          </p>
          <p className="mb-5 text-sm opacity-70">
            To claim an angel investor profile, you need to subscribe to our Angel Investor Registration Plan. 
            This plan gives you exclusive access to claim and manage angel investor profiles.
          </p>
          <Button
            onClick={toPricing}
            variant="secondary"
            className="w-full"
          >
            Upgrade
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}

export default ClaimModalPay;
